import React, { useContext, useState } from "react";
import "./webinarLandingPage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import AbuotUs from "../../assets/images/new/media.png";
import ContavtImg from "../../assets/images/new/mainimg.png";
import Pitrupaksh from "../../assets/images/new/pitrupaksha.png";
import Abuotws from "../../assets/images/new/media-two.png";
import "swiper/css";
import "swiper/css/navigation";

import batuk from "../../assets/images/new/fav-removebg-preview.png";
import whyChooseUsImg from "../../assets/images/new/whyChooseUs.png";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import { ContactUSApi } from "../../ApiServices/NewsLettter/NewsLetterApi";
import { useNavigate } from "react-router-dom";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import LazySection from "../Home/LazySection";
import FAQSection from "../../Components/FAQSection/FAQ";
import mainLogo from "../../../src/assets/images/new/logo.png";
import { WebinarUser } from "../../ApiServices/Webinar/WebinarApi";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import axios from "axios";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { Helmet } from "react-helmet-async";
import RazorpayWebinarPaymentButton from "./RazorpayWebinarPaymentButton";
import ComingSoonModal from "../../Components/ComingSoonModal";

const PitrupakshaWebinar = () => {
  const { setLoader } = useContext(LoaderContext);
  const slides = [
    {
      image: "../../assets/images/new/aboutPageImg.png",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "85%",
      goal: "$23,000 Goals",
      donated: "$9,000 Donate",
      color: "#ffa415",
      shape: "assets/images/shapes/d-shape-1.png",
    },
    {
      image: "assets/images/donation/donation-1-2.jpg",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "80%",
      goal: "$13,000 Goals",
      donated: "$5,000 Donate",
      color: "#ff5528",
      shape: "assets/images/shapes/d-shape-2.png",
    },
    // Add more slides here if needed
  ];
  const [Action, setAction] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const navigate = useNavigate();
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const [contactData, setContactData] = useState({
    email: null,
    LastName: null,
    email: null,
    mobileNumber: null,
    Message: null,
  });
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(null);

  const metaDataDetails = {
    MetaTitle: "Myomnamo Pitru Paksha Webinar in Marathi 7 September 2025 10 am to 11:30 am.",
    MetaDescription:
      "Join Myomnamo's Ganeshotsav webinar! Learn the complete guide to Ganesh Puja rituals, traditions & tips for a blissful celebration.",
    OpenGraphTag:
      "Myomnamo Presents Webinar: Complete Guide to Ganeshotsav Puja Rituals",
    CanonicalTag: "https://www.myomnamo.com/webinar",
  };

  function onCaptchaChange(value) {
    console.log("Captcha value:", value);
    setVerified(true);
  }

  const handleContactFormSubmit = () => {
    let isValid = false;
    if (
      contactData.fullName === "" ||
      contactData.fullName === undefined ||
      contactData.fullName === null ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.mobileNumber === "" ||
      contactData.mobileNumber === undefined ||
      contactData.mobileNumber === null ||
      contactData?.mobileNumber?.length !== 10 ||
      // contactData.Message === "" ||
      // contactData.Message === undefined ||
      // contactData.Message === null ||
      contactData.email === "" ||
      contactData.email === undefined ||
      contactData.email === null
    ) {
      isValid = true;
      setError(true);
    } else if (
      contactData.email !== null &&
      !validateEmail(contactData.email)
    ) {
      isValid = true;
      setError(true);
    }

    const api_params = {
      fullName: contactData.fullName,
      LastName: contactData.LastName,
      email: contactData.email,
      mobileNumber: contactData.mobileNumber,
      Message: contactData.Message,
    };

    if (!isValid) {
      handleRazorpayPayment();
    }
  };

  const WebinarUserData = async (api_params) => {
    try {
      const res = await WebinarUser(api_params);

      if (res.ResponseMessage === "Success.") {
        navigate("/thank-you", {
          state: { moduleName: "ContactUs" },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeAll = () => {
    // debugger;
    setShowSuccessPopUp(false);
    setInitialData();
  };

  const setInitialData = () => {
    setError(false);
    setContactData((prev) => ({
      ...prev,
      fullName: "",
      LastName: "",
      email: "",
      mobileNumber: "",
      Message: "",
    }));
  };
  //   const WebinarUserData = (params) => {
  //     const templateParams = {
  //       Name: params.name,
  //       email: params.email,
  //       "Mobile Number": params.mobileNo,
  //       message: params.message,
  //       //   to_name: "Velvet Admin",
  //       //   from_name: "Velvet mail service",
  //       //   receiver_email: "velvetgps@gmail.com",
  //     };

  //     emailjs
  //       .send(
  //         "service_wp19bkh", // Service ID
  //         "template_b9wrsrm", // Template ID
  //         templateParams, // Template Parameters
  //         "e5YUU5XlmWckFjZk_" // Public Key
  //       )
  //       .then(
  //         () => {
  //           console.log("SUCCESS!");
  //           setShowThanksModal(true);
  //         },
  //         (error) => {
  //           console.log("FAILED...", error.text);
  //         }
  //       );
  //   };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    let { id, value } = e.target;

    if (id === "fullName" || id === "lastName") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (id === "mobileNumber") {
      value =
        value.charAt(0) >= "6" ? value.replace(/\D/g, "").slice(0, 10) : ""; // Only keep digits and slice to 10 digits
    }

    setContactData((prev) => ({ ...prev, [id]: value }));
  };

  const handleRazorpayPayment = async () => {
    let orderIDReturned = null;
    setLoader(true);
    const PlaceOrderResponse = await handleProceedRemainingPayment("51");
    console.log("PlaceOrderResponse", PlaceOrderResponse);

    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/Webinar/WebinarUser`, {
          Name: contactData.fullName,
          EmailID: contactData.email,
          WhatsappNumber: contactData.mobileNumber,
          WebinarFee: 51,
          PaymentStatus: true,
          TransactionID: PlaceOrderResponse?.razorpay_payment_id,
        })
        .then((res) => {
          if (res) {
            console.log(res);

            orderIDReturned = res.data.ID;
            setLoader(false);
            // navigate("/thank-you", {
            //   state: { moduleName: "WebinarPage" },
            // });
            setInitialData();
            setShowComingSoonModal(true);
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false);
      alert("Payment Failed !");
    }
  };

  const HandleJoinNowClicked = () => {
    window.open("https://pages.razorpay.com/pl_RCJG0gKFvZ70dr/view", "_blank");
  };

  return (
    <>
      <Helmet>
        <title>{metaDataDetails?.MetaTitle}</title>
        <meta name="description" content={metaDataDetails?.MetaDescription} />
        <link rel="canonical" href={metaDataDetails?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={metaDataDetails?.OpenGraphTag} />
        <meta
          property="og:description"
          content="Celebrate Ganeshotsav with devotion & knowledge. Join our webinar to learn step-by-step Ganesh Puja rituals & traditions."
        />
        <meta property="og:image" content="" />
        <meta property="og:url" content={`https://www.myomnamo.com/webinar`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaDataDetails?.MetaTitle} />
        <meta
          name="twitter:description"
          content={metaDataDetails?.MetaDescription}
        />

        <script>
          {`
            !function(f,b,e,v,n,t,s){
              if(f.fbq) return; 
              n=f.fbq=function(){n.callMethod ? 
              n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
              if(!f._fbq) f._fbq=n;
              n.push=n; n.loaded=!0; n.version='2.0';
              n.queue=[]; t=b.createElement(e); t.async=!0;
              t.src=v; s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '24982247501377559');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=24982247501377559&ev=PageView&noscript=1"/>`}
        </noscript>
      </Helmet>

      {/* <section className="about-three">
        <div className="sec-title text-center" style={{ paddingBottom: "0px" }}>
          <h6
            className="sec-title__tagline"
            style={{
              perspective: "400px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img className=" tagline-img" src={batuk} alt="" /> Webinar Topic:

         
          </h6>
          <h3
            className="sec-title__title"
            style={{
              perspective: "400px",
              textAlign: "center",
              marginBottom: "50px",
            }}
          >
         The webinar is divided in to below 2 topics.

          </h3>
        </div>
        <div className="container">
            
          <div className="row">
            <div className="col-lg-8 wow fadeInLeft" data-wow-delay="100ms">
              <div className="about-three__content">
               
                <p
                  className="about-three__content__text text-dark"
                  style={{ textAlign: "justify" }}
                >
                 <ul className="text-muted ps-4">
                        <li>The main rituals of Ganesh Chaturthi: Pranapratishhtha (invoking life into the idol), Shhodashopachara (16 types of offerings), Uttarpuja (farewell ritual), and Ganpati Visarjan (immersion of the idol).
</li>
                        <li>Step-by-step explanation of the puja vidhi, including significance and meanings behind each ritual gesture
</li>
                        
                      </ul>
                </p>
               
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className=""
                data-wow-delay="200ms"
                style={{
                  paddingTop: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="about-three__image__shape-one">
                 
                </div>
                <img src={whyChooseUsImg} className="height2" alt="careox" />
                <div
                  className="about-three__image__right wow fadeInUp"
                  data-wow-delay="300ms"
                >
                 
                </div>
                <div className="about-three__image__shape-two">
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <header className="navbar">
        <div className="container">
          <div className="navbar-logo">
            <img src={mainLogo} alt="Logo" />
          </div>
          {/* <nav className="nav-links">
            <span>वेबिनार बघा</span>
            <span>फायदे</span>
            <span>नोंदणी</span>
          </nav> */}
          {/* <div className="nav-buttons">
            <button className="register-btn">आता नोंदणी करा</button>
            <button className="lang-btn">मराठी</button>
            <button className="lang-outline">English</button>
          </div> */}
        </div>
      </header>

      <section className="pitru-section py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Content */}
            <div
              className="col-lg-7 mb-4 mb-lg-0 wow fadeInLeft pitru-left"
              data-wow-delay="100ms"
            >
              <div className="pitru-content">
                {/* Title */}
                <h3 className="pitru-title">
                  पितृपक्ष समजून घेणे - आपल्या पूर्वजांचा आदर करणे
                </h3>
                <p className="pitru-subtitle">
                  पितृपक्षाच्या १६ दिवसांच्या पवित्र कालावधीचा शोध घेण्यासाठी
                  आमच्या वेबिनारमध्ये सामील व्हा, ज्या दरम्यान आपण पारंपारिक
                  विधी आणि अर्पणांद्वारे आपल्या पूर्वजांना श्रद्धांजली अर्पण
                  करतो. शांती, आशीर्वाद आणि कर्मशुद्धीकरणाला प्रोत्साहन देणाऱ्या
                  या महत्त्वपूर्ण हिंदू पाळण्याशी जोडण्यासाठी आध्यात्मिक
                  महत्त्व, पारंपारिक रीतिरिवाज आणि आधुनिक दृष्टिकोन शोधा.
                </p>

                {/* Details */}
                <div className="pitru-info-boxes">
                  {/* Details Box */}
                  <div className="pitru-details-card">
                    <ul className="pitru-list">
                      <li>
                        <i className="fa-solid fa-calendar"></i>{" "}
                        <span className="boldcolor"> दिनांक : </span> ७ सप्टेंबर
                        २०२५
                      </li>
                      <li>
                        <i className="fa-solid fa-clock"></i>
                        <span className="boldcolor"> वेळ : </span> सकाळी १० ते
                        ११:३०
                      </li>
                      <li>
                        <i className="fa-solid fa-hourglass-half"></i>
                        <span className="boldcolor"> कालावधी : </span>१ : 30 तास
                      </li>
                      <li>
                        <i className="fa-solid fa-language"></i>
                        <span className="boldcolor"> भाषा : </span>मराठी
                      </li>
                      <li>
                        <i className="fa-solid fa-laptop"></i>{" "}
                        <span className="boldcolor">प्लॅटफॉर्म : </span> झूम
                      </li>
                    </ul>
                  </div>

                  {/* Price Box */}
                  <div className="pitru-price-card">
                    <span className="pitru-price-label">₹ शुल्क</span>
                    <span className="pitru-price">५१</span>
                  </div>
                </div>
                <button
                  type="submit"
                  onClick={() => HandleJoinNowClicked()}
                  className="careox-btn pitru-button"
                >
                  <i
                    className="fa-solid fa-user-plus"
                    style={{ marginRight: "8px" }}
                  ></i>
                  <span className="pitrupakshabut">आता नोंदणी करा</span>
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-5 pitru-right wow fadeInRight">
              <div className="pitru-image">
                <img src={Pitrupaksh} alt="Pitru Paksha Ritual" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="shraddha-section">
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha">श्राद्ध पूजा सेवा</h2>
          <p className="sub-heading pitrru-subheading">
            आमच्या द्वारे आयोजित श्राद्ध पूजा आपल्या पितरांच्या शांतीसाठी आणि
            कुटुंबाच्या मंगलकामनेसाठी केली जाते.
          </p>
        </div>
        <div className="container shraddha-container">
          {/* Left Side - Heading */}

          {/* Right Side - Cards */}
          <div className="puja-cards">
            {/* Card 1 */}
            <div className="puja-card">
              <h3 className="puja-title">त्रिपिंडी श्राद्ध पूजा</h3>
              <p className="puja-desc">
                पितृपक्षातील ही पवित्र विधी पितृदोष निवारणासाठी अत्यंत प्रभावी मानली जाते. या पूजेतून अपूर्ण श्राद्ध व अकाल मृत आत्म्यांना शांती मिळते. पितरांचे आशीर्वाद लाभल्याने घरात सुख-समृद्धी, शांती व समाधान नांदते.

              </p>
            </div>

            {/* Card 2 */}


            {/* Card 3 */}
            <div className="puja-card">
              <h3 className="puja-title">नारायण नागबळी पूजा</h3>
              <p className="puja-desc">
                ही विशेष पूजा अकाल मृत्यू झालेल्या आत्म्यांच्या मुक्तीसाठी केली जाते. पितृदोष, वंशवृद्धीतील अडथळे व कौटुंबिक अडचणी दूर करण्यासाठी या विधीला विशेष महत्त्व आहे. नारायणाच्या कृपेने कुटुंबावर मंगलमय आशीर्वादाचा वर्षाव होतो.

              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="contact-section-custom py-5 mobile-secone">
        <div className="container">
          <div className="row align-items-center">
          
            <div
              className="col-lg-6 mb-4 mb-lg-0 wow fadeInLeft main-topicwebinar"
              data-wow-delay="100ms"
            >
              <div className="about-three__content">
                <img
                  src={ContavtImg}
                  alt="Pitru Paksha Ritual"
                  className="maincontactimg"
                />
              </div>
            </div>

          
            <div className="col-lg-6">
              <div className="form-card shadow-sm rounded bg-white padding-webinar">
                <div className="row gy-3">
               
                  <h3 className="fw-bold mb-3 text-primary mane-webinarhead">
                    संपर्क माहिती
                  </h3>

                
                  <div className="col-md-12 col-webinar">
                    <label className="form-label-custom webinar-label">
                      पूर्ण नाव <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      value={contactData?.fullName}
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="पूर्ण नाव टाका"
                      maxLength={50}
                    />
                    {error &&
                    (contactData?.fullName === null ||
                      contactData?.fullName === undefined ||
                      contactData?.fullName === "") ? (
                      <span
                        className="text-danger "
                        style={{ fontSize: "14px" }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

               
                  <div className="col-md-6 col-webinar">
                    <label className="form-label-custom webinar-label">
                      व्हॉट्सॲप क्रमांक <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="mobileNumber"
                      value={contactData?.mobileNumber}
                      onChange={handleChange}
                      className="form-input webinar-form"
                      maxLength={10}
                      placeholder="व्हॉट्सॲप क्रमांक टाका"
                    />
                    {error &&
                    (contactData?.mobileNumber === null ||
                      contactData?.mobileNumber === undefined ||
                      contactData?.mobileNumber === "") ? (
                      <span
                        className="text-danger "
                        style={{ fontSize: "14px" }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : error &&
                      contactData?.mobileNumber !== null &&
                      contactData?.mobileNumber !== "" &&
                      contactData?.mobileNumber !== undefined &&
                      contactData?.mobileNumber?.length !== 10 ? (
                      <span
                        className="text-danger"
                        style={{ fontSize: "14px" }}
                      >
                        अवैध मोबाईल क्रमांक
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

                 
                  <div className="col-md-6 col-webinar">
                    <label className="form-label-custom webinar-label">
                      ई-मेल <span>*</span>
                    </label>
                    <input
                      value={contactData?.email}
                      type="email"
                      id="email"
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="ई-मेल आयडी टाका"
                    />
                    {error &&
                    (contactData?.email === null ||
                      contactData?.email === undefined ||
                      contactData?.email === "") ? (
                      <span
                        className="text-danger"
                        style={{ fontSize: "14px" }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : error &&
                      contactData?.email !== null &&
                      contactData?.email !== undefined &&
                      contactData?.email !== "" &&
                      !validateEmail(contactData?.email) ? (
                      <span
                        className="text-danger"
                        style={{ fontSize: "14px" }}
                      >
                        अवैध ई-मेल आयडी
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

               
                <div className="mt-0 text-start">
                  <button
                    type="submit"
                    className="careox-btn wbinar-form submit-button"
                    onClick={() => handleContactFormSubmit()}
                  >
                    <span>सबमिट करा</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="shraddha-section cta-pitrupaksha">
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha pitrupaksha-headingcta mobile-alignament">
            मर्यादित जागा! आताच नोंदणी करा
          </h2>
          <div className="button-wrapper">
            <button
              type="submit"
              onClick={() => HandleJoinNowClicked()}
              className="careox-btn cta-pitrupakshaone"
            >
              <i
                className="fa-solid fa-user-plus"
                style={{ marginRight: "8px" }}
              ></i>
              <span className="pitrupakshabutone">आता नोंदणी करा</span>
            </button>
          </div>
        </div>
      </section>
      <section className="donate-page">
        <div className="container">
          <div className="row">
            {/* Left Column: Donation Form */}
            <div className="col-lg-8">
              <div className="donate-page__content">
                <div className="donate-page__notice p-4 rounded shadow-sm bg-light border">
                  <div className="donate-page__notice__icon mb-3"></div>

                  <div className="ganesh-rituals">
                    <h3 className="fw-bold mb-3 text-primary mane-webinarhead">
                      हा वेबिनार का अटेंड करावा?

                    </h3>
                    <p className="webinar-paragraph">
                      <div className="benefits-grid">

                        <div className="benefit-card">
                          <span className="benefit-number">१</span>
                          <p className="benefit-text">
                            <b>आध्यात्मिक महत्त्व – </b>पितृपक्षातील विधींचे तात्त्विक व धार्मिक महत्त्व जाणून घेता येईल.
                          </p>
                        </div>

                        <div className="benefit-card">
                          <span className="benefit-number">२</span>
                          <p className="benefit-text">
                            <b>गुरुजींचे मार्गदर्शन – </b> अनुभवी गुरुजींकडून थेट मार्गदर्शन मिळेल व शास्त्रशुद्ध माहिती समजेल.
                          </p>
                        </div>

                        <div className="benefit-card">
                          <span className="benefit-number">३</span>
                          <p className="benefit-text">
                            <b>व्यवहार्य ज्ञान – </b> नारायण नागबली आणि त्रिपिंडी श्राद्ध विधी कसे योग्य प्रकारे करावेत याचे प्रत्यक्ष ज्ञान मिळेल.
                          </p>
                        </div>

                        <div className="benefit-card">
                          <span className="benefit-number">४</span>
                          <p className="benefit-text">
                            <b> संस्कृतीची जाण –</b> भारतीय संस्कृतीतील पितृपूजेचे स्थान आणि पारंपरिक मूल्ये समजून घेता येतील.
                          </p>
                        </div>

                        <div className="benefit-card">
                          <span className="benefit-number">५</span>
                          <p className="benefit-text">
                            <b>कुटुंबाचे कल्याण –</b> पितृशांती साधून कुटुंबाला समाधान, सुख-समृद्धी आणि आशीर्वाद प्राप्त होतो.
                          </p>
                        </div>
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Swiper Carousel */}
            <div className="col-lg-4">
              <div className="donate-page__sidebar">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={30}
                  slidesPerView={1}
                  // autoplay={{ delay: 3000, disableOnInteraction: false }}
                  navigation={true}
                >
                  {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="donations-one__item"
                        style={{ "--accent-color": slide.color }}
                      >
                        <div className="donations-one__item__image">
                          <img src={AbuotUs} alt="careox" />
                          <a
                            href="donation-details.html"
                            className="donations-one__item__image__link"
                          ></a>
                        </div>
                        <div className="donations-one__item__content">
                          <h6
                            className="sec-title__tagline bw-split-in-right addingheading-webinar"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                            }}
                          >
                            हजारो लोकांनी अनुभवलेल्या या आध्यात्मिक प्रवासात
                            सामील व्हा
                          </h6>

                          <button
                            type="submit"
                            className="careox-btn pitru-button"
                            style={{ margin: "0px" }}
                            onClick={() => HandleJoinNowClicked()}
                          >
                            <i
                              className="fa-solid fa-user-plus"
                              style={{ marginRight: "8px" }}
                            ></i>
                            <span> आता तुमची पाळी - नोंदणी करा</span>
                          </button>

                          {/* <RazorpayWebinarPaymentButton /> */}
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of Donate Section */}
      {/* <section className="shraddha-area py-5">
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha-mahiti">
            मुख्य श्राद्ध खालीलप्रमाणे
          </h2>
          <p className="sub-heading pitrru-subheading--mahiti">
            आमच्या द्वारे आयोजित श्राद्ध पूजा आपल्या पितरांच्या शांतीसाठी आणि
            कुटुंबाच्या मंगलकामनेसाठी केली जाते.
          </p>
        </div>
        <div className="container">
          <div className="row">
         
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>१. भरणी श्राद्ध</h4>
                <p>
                  नुकत्याच देह्कार्य झालेल्या म्हणजे चालू वर्षातच मृत पावलेल्या
                  व्यक्तींसाठी भरणी श्राद्ध घातले जाते. पितृपक्षामधील चतुर्थी
                  किंव्हा पंचमीला भरणी नक्षत्रावर हे कार्य पूर्ण केले जाते. हे
                  श्राध्द केल्याने मृतआत्म्यास शांती मिळून त्यांची भौतिकतेच्या
                  मोहजालातून सुटका होते. या विधी मुळे गया श्राद्धासारखे पुण्य
                  मिळतेअसे म्हंटले जाते.
                </p>
              </div>
            </div>

          
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>२. हिरण्य श्राद्ध</h4>
                <p>
                  ज्या श्राद्धात शास्त्रोत विधी पूर्ण करण्यासाठी यजमान शिजवलेले
                  अन्न देऊ शकत नाहीत त्यावेळी हिरण्य श्राद्ध घातले जाते. अनेक
                  वेळी यजमान परदेशी असू शकतात, वेळेअभावी अशी काही कारणे असू
                  शकतात. त्या वेळी फळे, कच्चे तांदूळ, डाळ साखर अश्या काही
                  गोष्टींचा उपयोग विधीमध्ये करता येतो.
                </p>
              </div>
            </div>

        
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>३. पावर्ण श्राद्ध</h4>
                <p>
                  पावर्ण याचा अर्थ होतो विशेष प्रसंग अथवा विशेष प्रसंगानुरूप. हा
                  विधी सर्व पितरांसाठी एकत्रित पणे करायचा असल्याने पितृपक्षात हे
                  श्राद्ध साधारणपणे शेवटच्या दिवशी अमावस्येला केले जाते. या मुळे
                  चुकून माकून आपल्या कडून राहून गेलेल्या व्यक्तिंस हि मुक्ती
                  मिळून जाते. या पूजेमुळे पितरांच्या आत्म्याला शांती लाभते व
                  घरातील सर्व अडथळे दूर होतात. कुटुंबातील सर्वांना आरोग्य, आनंद
                  व समृद्धी प्राप्त होऊन घरातील वातावरण मंगलमय होते.
                </p>
              </div>
            </div>

        
            <div className="col-lg-6 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>४. पिंडदान</h4>
                <p>
                  पिंडदान हा एक महत्वाचा विधी आहे, यात मृत आत्म्यास अन्न व जल
                  अर्पण केले जाते. तांदूळ, काळे तीळ व इतर धान्यांपासून बनवलेले
                  गोलाकार पिंड यावेळी अर्पण करतात. या पिंडास कावळा शिवणे
                  महत्वाचे मानले गेले आहे. जेणेकरून आपल्या पूर्वजांना मोक्ष
                  मिळेल. जन्मापासून सुरु झालेला प्रवास मोक्ष प्राप्तीपर्यंत
                  संपतो. हा प्रवास अधिक सुखकर मोक्षा पर्यंत पूर्ण व्हावा हा
                  हेतूने हे पिंडदान करतात .हे विधी मुलगा किंव्हा नातू च्या हातून
                  केले जातात.
                </p>
              </div>
            </div>

            <div className="col-lg-12 mb-4 d-flex">
              <div className="shraddha-card flex-fill">
                <h4>५. तर्पण</h4>
                <p>
                  फक्त हिंदू च नाही तर मानवता धर्मात देखील तहानलेल्या जीवास पाणी
                  दिल्याने पुण्य प्राप्र्त होते कारण समोरच्याचा आत्मा शांत होतो
                  व आपल्यास आपोआप च आशिर्वाद मिळतात. तर्पण हे पितृपक्षात
                  कोणत्याही दिवशी करू शकतो यामुळे आत्मा संतुष्ट होतो. यात
                  मुख्यत्वे उदक म्हणजेच जल व धान्य अर्पण केले जाते. पवित्र
                  गंगेचे जल किंव्हा शुध्द मनाने चांगल्या हेतूने पितरांचे तर्पण
                  केल्यास पितृदोषापासून हि मुक्ती मिळते असे म्हणतात.पितृ पक्ष हा
                  हिंदू धर्मातील अतिशय महत्वपूर्ण कालावधी आहे, ज्यामध्ये आपण
                  आपल्या पूर्वजांचे स्मरण करून त्यांना तर्पण, श्राद्ध आणि
                  पिंडदान या धार्मिक विधींनी आदरपूर्वक श्रद्धांजली अर्पण करतो.
                  या काळात असे मानले जाते की, पूर्वजांचे आत्मे पृथ्वीवर येतात
                  आणि आपल्या वंशजांकडून अर्पण केलेली अन्न-वस्त्रे-जल स्वीकारतात.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "0px",
          }}
        >
          <button
            type="submit"
            className="careox-btn button-webinar"
            onClick={() => HandleJoinNowClicked()}
          >
            <i
              className="fa-solid fa-user-plus"
              style={{ marginRight: "8px" }}
            ></i>
            <span> तातडीने नोंदणी करा</span>
          </button>
        </div>
      </section> */}
      <section className="pitruinfo-section py-12 bg-gray-50">
        <div className="pitruinfo-wrapper">
          <div className="container">
            <div className="pitruinfo-card">
              <h2 className="pitruinfo-title">
                पितृ पक्ष : आध्यात्मिक आणि सामाजिक महत्त्व
              </h2>
              <div className="pitruinfo-content">
                <div className="pitruinfo-point">
                  <span className="pitruinfo-icon">📖</span>
                  <p>
                    <b>परिभाषा:</b> पितृ पक्ष किंवा श्राद्ध पक्ष हा भाद्रपद
                    महिन्यातील कृष्ण पक्षातील १६ दिवसांचा कालावधी असतो. यामध्ये
                    आपले गेल्या पिढ्यांचे स्मरण आणि त्यांना शांतीचा लाभ व्हावा
                    यासाठी श्राद्ध, तर्पण व पिंडदान केले जाते.
                  </p>
                </div>

                <div className="pitruinfo-point">
                  <span className="pitruinfo-icon">🙏</span>
                  <p>
                    <b>विश्वास:</b> असे मानले जाते की या काळात आपल्या पूर्वजांचे
                    आत्मे आपल्या घरी येऊन श्रद्धेने अर्पण केलेले जल, अन्न आणि
                    वस्त्र स्विकारतात, त्यामुळे त्यांच्या आत्म्याला शांती मिळते
                    आणि वंशाला कल्याण मिळते.
                  </p>
                </div>

                <div className="pitruinfo-point">
                  <span className="pitruinfo-icon">🌸</span>
                  <p>
                    <b>उद्देश:</b> या धार्मिक विधींमुळे पूर्वजांचे ऋण फेडले
                    जाते, वंशातील पितृदोष दूर होतो आणि कुटुंबात समृद्धी, आरोग्य
                    व शांती लाभते, असे शास्त्रांमध्ये नमूद आहे.
                  </p>
                </div>

                <div className="pitruinfo-point">
                  <span className="pitruinfo-icon">🪔</span>
                  <p>
                    <b>परंपरा आणि संस्कृति:</b> पितृ पक्ष सनातन संस्कृतीतील
                    कुटुंब आणि वंशाच्या सातत्याची आणि कृतज्ञतेची भावना दृढ
                    करणारा कालखंड आहे.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="shraddha-section info-pitrupaksh">
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha pitrupaksha-headingcta align-left">
            त्र्यंबकेश्वर या स्थळी विशेष महत्त्व
          </h2>
          <p className="trambakparagraph">
            त्र्यंबकेश्वर  पितृ पक्षातील त्रिपिंडी पूजा आणि नारायण नागबळी पूजा या साठी  त्र्यंबकेश्वर  तीर्थस्थळांला  विशेष महत्त्व आहे. येथे पारंपरिक पद्धतीने पुरोहितांकडून विधी केल्याने पूर्वजांना मोक्षप्राप्ती होते, असे मानले जाते.

          </p>
          <button
            type="submit"
            onClick={() => HandleJoinNowClicked()}
            className="careox-btn cta-pitrupakshaone "
            style={{ marginTop: "0px" }}
          >
            <i
              className="fa-solid fa-user-plus"
              style={{ marginRight: "8px" }}
            ></i>
            <span className="pitrupakshabutone">आता नोंदणी करा</span>
          </button>
        </div>
      </section>
      <section className="pitru-benefits-section py-12 main-colocr">
        <div className="pitru-container">
          <h2 className="pitru-benefits-title">आध्यात्मिक आणि भावनिक लाभ</h2>
          <div className="pitru-benefits-grid">
            <div className="pitru-benefit-card">
              <span className="pitru-benefit-icon">✨</span>
              <h3 className="pitru-benefit-heading">
                आयुष्यातील अडथळ्यांपासून मुक्ती
              </h3>
              <p className="pitru-benefit-text">
                आपल्या पूर्वजांचे आशीर्वाद या काळात मिळविल्यास कुटुंबातील अडथळे
                व अडचणी दूर होतात, अशी श्रद्धा आहे.
              </p>
            </div>

            <div className="pitru-benefit-card">
              <span className="pitru-benefit-icon">🤝</span>
              <h3 className="pitru-benefit-heading">
                कुटुंब नातेसंबंध दृढ होणे
              </h3>
              <p className="pitru-benefit-text">
                पितृ पक्षामुळे पिढ्यान्पिढ्या भावनिक जोड कायम राहते आणि वंशाचा
                सातत्याचा संस्कार दृढ होतो.
              </p>
            </div>

            <div className="pitru-benefit-card">
              <span className="pitru-benefit-icon">🕉️</span>
              <h3 className="pitru-benefit-heading">मोक्षप्राप्ती</h3>
              <p className="pitru-benefit-text">
                स्नान, तर्पण, दान, पिंडदान व श्राद्ध केल्याने पितरांना मोक्ष
                मिळतो, असे धर्मग्रंथ सांगतात.
              </p>
            </div>
          </div>
        </div>
      </section>

      <LazySection>
        <FAQSection languageID={1} />
      </LazySection>
      <footer className="footer">
        <div className="footer-container">
          {/* Left Side - Logo + Tagline */}
          <div className="footer-left">
            <img src={mainLogo} alt="Logo" className="footer-logo" />
            <p className="footer-tagline">आपली आध्यात्मिक प्रवास सुधारा</p>
          </div>

          {/* Right Side - Contact Info */}
          <div className="footer-right">
            <h3 className="footer-heading">संपर्क</h3>
            <p>
              <i
                className="fa-solid fa-phone"
                style={{ marginRight: "8px" }}
              ></i>
              +91 91195 55461
            </p>
            <p>
              <i
                className="fa-solid fa-envelope"
                style={{ marginRight: "8px" }}
              ></i>
              info@myomnamo.com
            </p>

            {/* Social Icons */}
            <div className="footer-social">
              <a href="#">
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <p className="footer-bottomlink">
            © 2025 माय ओम नमो. सर्व हक्क राखीव.
          </p>
        </div>

        {/* Floating Buttons */}
        <div className="floating-buttons">
          <a href="#top" className="scroll-top">
            <i className="fa-solid fa-arrow-up"></i>
          </a>
          <a
            href="https://api.whatsapp.com/send/?phone=919975267711"
            target="_blank"
            className="whatsapp"
          >
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </footer>
      <ComingSoonModal
        show={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
        moduleName="e-webinar"
      />
    </>
  );
};
export default PitrupakshaWebinar;
